export * from './createAlternativeTableEndpoint';
